import React from 'react';

class SiteFooter extends React.Component {
	render() {
		return <div className="site-footer">
			<div className="footer-text">Stofnun Árna Magnússonar í íslenskum fræðum, Árnagarði við Suðurgötu, 101 Reykjavík - <a href="http://ordabanki.hi.is/wordbank/login">Innskráning ritstjóra</a></div>
			<p className="mt-4">
				<a href="https://termbank.arnastofnun.is/"><img width="182" src="https://termbank.arnastofnun.is/assets/images/logo/etb-logo.svg" class="etb-logo mr-3" /></a>
			</p>
		</div>;
	}
}

export default SiteFooter;



// WEBPACK FOOTER //
// ./src/components/SiteFooter.js